import { Component } from 'react';

export default class MoneySelector extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false, ignoreFocus: false };
  }

  onChange(event) {
    let value = parseInt(event.target.value.replace('$', ''), 10);
    if (isNaN(value)) {
      value = '';
    }
    if (value < 0) {
      value = Math.abs(value);
    }
    this.props.onChange(value);
  }

  handleFocus(event) {
    if (this.state.ignoreFocus) {
      this.setState({ ignoreFocus: false });
    } else {
      this.setState({ open: true });
    }
  }

  handleBlur(event) {
    this.setState({ open: false });
  }

  handleSelection(value) {
    if (value === 'other') {
      this.setState({ open: false, ignoreFocus: true }, () => {
        _.delay(() => {
          this.input.focus();
        }, 1);
      });
    } else {
      this.props.onChange(value);
    }
  }

  getOptionValues() {
    if (this.props.frequency === 'monthly') {
      return {
        15: '$15',
        25: '$25',
        35: '$35',
        other: 'Other',
      };
    } else {
      return {
        50: '$50',
        100: '$100',
        250: '$250',
        1000: '$1,000',
        other: 'Other',
      };
    }
  }

  render() {
    const optionValues = this.getOptionValues();
    const options = Object.keys(optionValues).map((key) => {
      return (
        <div
          className="custom-select-option money-selector-option"
          key={key}
          onMouseDown={this.handleSelection.bind(this, key)}
        >
          {optionValues[key]}
        </div>
      );
    });
    const optionsMarkup = (
      <div className="money-selector-options custom-select-options">
        {options}
      </div>
    );

    let className = '';
    if (this.props.errors && this.props.errors.donationAmount) {
      className = 'error';
    }

    return (
      <div className={`custom-select money-selector inline-block ${className}`}>
        <input
          className="minimal-text-input money-selector-input"
          ref={(i) => {
            this.input = i;
          }}
          autoComplete="off"
          type="number"
          value={this.props.value}
          name="amount"
          placeholder=""
          onChange={this.onChange.bind(this)}
          onFocus={this.handleFocus.bind(this)}
          onBlur={this.handleBlur.bind(this)}
        />
        <span className="money-selector-symbol">$</span>
        {this.state.open && optionsMarkup}
      </div>
    );
  }
}
